import React, { useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { alertService } from '_services';
import { Link } from 'react-router-dom';
import { descargarFactura } from 'actions/archivos';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import Pagination from 'components/pagination/Pagination';
import { useForm } from 'react-hook-form';
import { currency, rfcValido } from 'resources/utilities';

import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';

import Swal from 'sweetalert2';

const Facturacion = ({ history, match, saludo, subtitulo }) => {
    const { id } = match.params;
    const [facturado, setFacturado] = useState(false);
    const { handleSubmit } = useForm();

    const [isOpenModal, openModal, closeModal] = useModal(false);
    const [modalValor, setModalValor] = useState(false);
    let [cfdi, setCfdi] = useState([]);
    let [art_id, setArtId] = useState('');
    let [articulo, setArticulo] = useState([]);

    const [initialObject, setInitialObject] = useState(true);
    const [initialObjectClaveUnidad, setInitialObjectClaveUnidad] = useState(true);

    let [cliente, setCliente] = useState([]);
    let [clientes, setClientes] = useState([]);
    let [direcciones, setDirecciones] = useState([]);
    let [direccionesList, setDireccionesList] = useState([]);
    let [venta, setVenta] = useState({
        id: 0,
        empresa_Id: getDataSession('empresa'),
        sucursal_Id: getDataSession('sucursal'),
        direccion_Id: 0,
        no_Orden: '',
        folio: '',
        moneda: 'MXN',
        descuento_Importe: 0,
        estatus: 'T',
        importe_Total_Impuestos: 0,
        metodo_Pago: '',
        clave_Envio: '',
        forma_De_Pago: ''
    });
    let [ventaDetalles, setVentaDetalles] = useState([]);
    let [articulos, setArticulos] = useState([]);

    let [serie, setSerie] = useState('');
    let [sucursal_id, setSucursal_id] = useState(getDataSession('sucursal'));

    let [sucursales, setSucursales] = useState([]);
    let [series, setSeries] = useState([]);

    var direccion_id = 0;

    const totalxPagina = 10;

    const busqueda = useFormInput('');
    let [error, setError] = useState(['']);
    let [errorRfc, setErrorRfc] = useState(['']);
    let [erroresCliente, setErroresCliente] = useState({});
    let [erroresDirecciones, setErroresDirecciones] = useState({});

    let [erroresV, setErroresV] = useState({});
    let [erroresArticulos, setErroresArticulos] = useState({});
    let [requiereRevision, setRequiereRevision] = useState(false);

    const [satUsoCfdi, setSatUsoCfdi] = useState(['']);
    const [satRegimenFiscal, setSatRegimenFiscal] = useState(['']);
    const [satFormaPago, setSatFormaPago] = useState(['']);
    const [satPais, setSatPais] = useState(['']);

    
async function getSatUsoCfdi() {
    const response = await fetchConToken(`CatalogosSat/ListUsoCfdi?pagina=1&totalXpagina=300`);
    setSatUsoCfdi(response);
}

async function getSatRegimelFiscal() {
    const response = await fetchConToken(`CatalogosSat/ListRegimenFiscal?pagina=1&totalXpagina=300`);
    setSatRegimenFiscal(response);
}

async function getSatFormaPago() {
    const response = await fetchConToken(`CatalogosSat/ListFormaPago?pagina=1&totalXpagina=300`);
    setSatFormaPago(response);
}

async function getSatPais() {
    const response = await fetchConToken(`CatalogosSat/ListPais?pagina=1&totalXpagina=300`);
    setSatPais(response);
}

    React.useEffect(() => {
         getCfdi();
        getSucursales();
        getSeries(getDataSession('sucursal'));   


        getSatUsoCfdi();
        getSatRegimelFiscal();
        getSatFormaPago();
        getSatPais();
        getVenta();
    }, []);

    async function getSucursales() {
        const response = await fetchConToken(
            `Sucursales/GetList?empresa_id=${getDataSession('empresa')}&pagina=1&totalXpagina=50`
        );
        setSucursales(response);
    }

    async function getSeries(sucursal_id) {
        const response = await fetchConToken(
            `Sucursales/GetFoliosSucursales?sucursal_Id=${sucursal_id}&tipo_Documento=F`
        );
        setSeries(response);
    }

    async function revisarArticulos(){
        var rep = await getVenta();
        if(rep)
        {
            Swal.fire('Atencion', 'Todavia tiene articulos pendientes a revision', 'info');
        }
        else
        {
            Swal.fire('Correcto', 'Articulos verificados, y detalles de la venta actualizados', 'success');
        }
    }
    /*async function getDireccion(direccion_id) {
        const direccionAux = await fetchConToken(`DireccionesClientes?id=${direccion_id}`);
        setDirecciones(direccionAux);
        console.log("set direccion");
        getCliente(direccionAux.cliente_Id);
    }

    async function getCliente(cliente_id) {
        console.log("entro get cliente");
        const clienteAux = await fetchConToken(
            `Clientes?id=${cliente_id}&sucursal_Id=${getDataSession('sucursal')}`
        );
        clienteAux.regimen_Fiscal_Receptor =
            clienteAux.regimen_Fiscal_Receptor.replace(' ') === ''
                ? '601'
                : clienteAux.regimen_Fiscal_Receptor;
        clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
        clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
        clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
        setCliente(clienteAux);
        console.log(clienteAux);
        console.log(clienteAux.clientes_Direcciones[0]);
    }*/

    function getCfdi() {
        fetchConToken(`Cfdis/GetVenta?id_venta=${id}`).then((response) => {
            if (response.hasOwnProperty('status') && response.status === 400) {
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                return false;
            }

            Swal.fire('', 'Esta venta ya fue facturada', 'info');
            //alertService.success('Esta venta ya fue facturada', { keepAfterRouteChange: true });
            //setError('Esta venta ya fue facturada');
            setCfdi(response);
            setFacturado(true);
            // history.push('..');
        });
    }

    async function getVenta() {
        const ventaAux = await fetchConToken(
            `Ventas?id=${id}&sucursal_Id=${getDataSession('sucursal')}`
        );
        ventaAux.forma_De_Pago =
            ventaAux.forma_De_Pago.replace(' ') === '' ? '01' : ventaAux.forma_De_Pago;
        ventaAux.metodo_Pago =
            ventaAux.metodo_Pago.replace(' ') === '' ? 'PUE' : ventaAux.metodo_Pago;

        setVenta(ventaAux);
        getDireccion(ventaAux.direccion_Id);
        articulos.length = 0;
        ventaAux.venta_Detalles?.map((item) => {
            articulos.push(item?.articulo);
            /* var porcentajeImp = 0;
            var imp = fetchConToken(`ImpuestosArticulos/GetList?articulo_Id=`+id)
            if(imp !== undefined)
            {
                var impAux = imp[0]?.tipo_impuesto;

                porcentajeImp = impAux?.porcentaje;
                porcentajeImp = porcentajeImp / 100;
            }
                if(porcentajeImp > 0)
                porcentajeImp = porcentajeImp;
                else
                porcentajeImp =0;

                console.log(porcentajeImp)
                item.impuesto=(item.costo_Unidad * porcentajeImp);
                item.precioSinImpuesto= (item.costo_Unidad - (item.costo_Unidad * porcentajeImp));
                item.subtotal= (item.precioSinImpuesto * item.cantidad);
                item.iva=(item.impuesto * item.cantidad);*/
        });
        setVentaDetalles(ventaAux.venta_Detalles);

        setRequiereRevision(ventaAux.venta_Detalles.filter(e => e.requiere_Revision === true).length > 0);

        if(ventaAux.es_Global && ventaAux.permitir_Nota_Credito)
        {
            Swal.fire('Importante', 'Esta venta pertenece a una factura global, al facturarla se creara una nota de credito ligada a la factura global correspondiente', 'info');
            setFacturado(false);
        }

        return ventaAux.venta_Detalles.filter(e => e.requiere_Revision === true).length > 0;
    }

    async function facturar(){
        /*if(errorRfc.length > 0)
        {
            setError("Escriba correctamente el RFC");
            return "";
        }*/

        if (await saveCliente()) {
            //if( await saveArticulos())
              facturarVenta(id);
        }
        
    };



    function facturarVenta(id){
        fetchConToken(`Facturacion?venta_Id=${id}&serie_Id=${serie}`).then((response) => {
            setError('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                //setError('Revisar muestra de errores');
                Object.entries(response.errors).map(([key, value]) => {
                    //erroresC[key] = value[0];
                    Swal.fire('Error', value[0], 'error'); //setErroresCliente(erroresC);
                    return false;
                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                //setError(response.mensajes[0]);
                return false;
            }
            //alertService.success('Facturado', { keepAfterRouteChange: true });
            Swal.fire('Exito', 'Facturado correctamente', 'success');
            setFacturado(true);
            setCfdi(response);
            // history.push('..');
        });
    };

    async function saveCliente(){ 
        if (!cliente.hasOwnProperty('uso_Cfdi')) cliente.uso_Cfdi = 'G01';
        if (!cliente.hasOwnProperty('regimen_Fiscal_Receptor'))
            cliente.regimen_Fiscal_Receptor = '601';

        if (!cliente.hasOwnProperty('no_Cliente')) cliente.no_Cliente = 'local';

        
        cliente.clientes_Direcciones = null;//direcciones.filter(item => item.id === direccion_id); 

        cliente.sucursal_Id = getDataSession('sucursal');
        let respuesta = await fetchConToken(
            `Clientes?sucursal_Id=${getDataSession('sucursal')}`,
            cliente,
            cliente.hasOwnProperty('id') && cliente.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresCliente('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                var erroresC = {};
                Object.entries(response.errors).map(([key, value]) => {
                    erroresC[key] = value[0];
                    Swal.fire('Error', value[0], 'error'); //setErroresCliente(erroresC);
                    return false;
                });
                setError('Revisar errores');
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                //setError(response.mensajes[0]);
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            setCliente([]);
            setCliente(response);
            return saveDireccion(response.id);

        });
        return respuesta;
        //.catch(alertService.error("91"));
    };

    async function saveDireccion(id){
        direcciones.cliente_Id = id;

        if (!direcciones.hasOwnProperty('no_Direccion')) direcciones.no_Direccion = 'local';

        let respuesta = await fetchConToken(
            `DireccionesClientes`,
            direcciones,
            direcciones.hasOwnProperty('id') && direcciones.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresDirecciones('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                var erroresC = {};
                Object.entries(response.errors).map(([key, value]) => {
                    //erroresC[key] = value[0];
                    //setErroresDirecciones(erroresC);
                    Swal.fire('Error', value[0], 'error');
                    return false;
                });
                setError('Revisar errores');
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                //setError(response.mensajes[0]);
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            setDirecciones([]);
            setDirecciones(response);
            direccion_id = response.id;
            return guardarVenta(response.id);
        });
        return respuesta;
        //.catch(alertService.error("107"));
    };

    ////////Guardar Venta
    ///////////////////////////////////////////
    async function guardarVenta(id){
        venta.sucursal_Id = getDataSession('sucursal');
        venta.direccion_Id = id;
        if (venta.direccion_Id === 0) {
            Swal.fire('Error', 'Seleccione una direccion', 'error');
            return false;
        }
        if (ventaDetalles.length === 0) {
            Swal.fire('Error', 'Seleccione por los menos un articulo', 'error');
            return false;
        }

        /*ventaDetalles.map(item=>{
            item.articulo = null;
        });
        */

        if (venta.forma_De_Pago.length === 0 || !venta.hasOwnProperty('forma_De_Pago'))
            venta.forma_De_Pago = '01';

        if (venta.metodo_Pago.length === 0 || !venta.hasOwnProperty('metodo_Pago'))
            venta.metodo_Pago = 'PUE';

        if (venta.length === 0 || !venta.hasOwnProperty('moneda')) venta.moneda = 'MXN';

        venta.venta_Detalles = ventaDetalles;

        let respuesta = await fetchConToken(
            `Ventas?sucursal_Id=${getDataSession('sucursal')}`,
            venta,
            venta.hasOwnProperty('id') && venta.id > 0 ? 'PUT' : 'POST'
        ).then((response) => {
            setErroresV({});
            if (response.hasOwnProperty('status') && response.status === 400) {
                var erroresVenta = {};
                Object.entries(response.errors).map(([key, value]) => {
                    //erroresVenta[key] = value[0];
                    //setErroresV(erroresVenta);
                    Swal.fire('Error', value[0], 'error');
                    return false;
                });
                setError('Revisar errores');
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                //setError(response.mensajes[0]);
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            //alertService.success('Venta guardada', { keepAfterRouteChange: true });
            //Swal.fire('Info','Venta facturada','Info')
            setError('');
            setVenta(response);

            getVenta();
            //setFacturado(true);
            return true;
        });
        return respuesta;
        //.catch(alertService.error("131"));
    };
    ///////////////////////////////////////////

    async function saveArticulos(){
        setErroresArticulos({});
        setError('');
        let articulosGuardados = true;
        let respuestaBool = true;
        await ventaDetalles.map(async (art) =>{
            art.articulo.descripcion =
                art.articulo.descripcion.replace(' ') === ' ' ? '' : art.articulo.descripcion;
            let articulosGuardados = await fetchConToken(
                `Articulos?sucursal_Id=${getDataSession('sucursal')}`,
                art.articulo,
                'PUT'
            ).then((response) => {
                if (response.hasOwnProperty('status')) {
                    var erroresA = {};
                    Object.entries(response.errors).map(([key, value]) => {
                        Swal.fire('Error', value[0], 'error');
                        //erroresA[key] = value[0] + ' Clave: ' + art.articulo.clave;
                        //setErroresArticulos(erroresA);
                        respuestaBool = false;
                    });
                    //setError('Revisar erroWWres');
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    //setError(response.mensajes[0]);
                    Swal.fire('Error', response.mensajes[0], 'error');
                    respuestaBool = false;
                }
                articulosGuardados = respuestaBool == false ? false : true;
            });
        });

        return articulosGuardados;
        /*if (Object.entries(erroresArticulos).length > 0) return false;
        if (erroresArticulos[0] !== undefined) return false;
        console.log("entro");
        return true;*/
    };

    /*React.useEffect(() => {
        getSucursales();
        getSeries(getDataSession('sucursal'));
    }, []);*/

    const handleInputChangeCliente = ({ target }) => {
        setCliente({
            ...cliente,
            [target.name]: target.value
        });

        if (target.name === 'rfc') {
            var rfcCorrecto = rfcValido(target.value, true);
            if (!rfcCorrecto) {
                setErrorRfc('RFC no valido');
            } else {
                setErrorRfc('');
            }
        }
    };

    const handleInputChangeDireccion = ({ target }) => {
        setDirecciones({
            ...direcciones,
            [target.name]: target.value
        });
    };
    const handleInputChangeVenta = ({ target }) => {
        setVenta({
            ...venta,
            [target.name]: target.value
        });
    };

    const handleInputChangeSerie = ({ target }) => {
        setSerie(target.value);
    };

    const handleInputChangeSucursal = ({ target }) => {
        venta.sucursal_id = target.value;
        setSucursal_id(target.value);
        getSeries(target.value);
    };

    const handleInputChangeArticulos = (event, key, campo) => {
        let detalleV = ventaDetalles.filter((det) => det.articulo_Id === key);
        detalleV[0].articulo[campo] = event.target.value;

        setVentaDetalles(ventaDetalles.map((det) => (det.articulo_Id === key ? detalleV[0] : det)));
    };

    async function eliminar(id) {
        setVentaDetalles([]);
        setVentaDetalles(ventaDetalles.filter((item) => item.articulo_Id !== id));
    }
    function handleInputChangeArticulo({target}) {
        setArticulo({
            ...articulo,
            [target.name]: target.value
        });
    }
    ////Clientes
    /////////////////////////////////////////////
    async function getClientes(page) {
        setModalValor('cliente');
        const response = await fetchConToken(
            `clientes/GetList?sucursal_id=${getDataSession('sucursal')}&empresa_id=${getDataSession(
                'empresa'
            )}&paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${busqueda.value}`
        );
        setClientes(response);
        //getDirecciones();
    }

    async function getCliente(cliente_id) {
        const clienteAux = await fetchConToken(
            `Clientes?id=${cliente_id}&sucursal_Id=${getDataSession('sucursal')}`
        );
        clienteAux.regimen_Fiscal_Receptor =
            clienteAux.regimen_Fiscal_Receptor.replace(' ') === ''
                ? '601'
                : clienteAux.regimen_Fiscal_Receptor;
        clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
        clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
        clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
        setCliente(clienteAux);
        setDirecciones(clienteAux.clientes_Direcciones[0]);
        venta.direccion_Id = clienteAux.clientes_Direcciones[0].id;
    }
    ////////////////////////////////////////////

    /////////Direcciones
    ///////////////////////////////////////////
    async function getDirecciones(page) {
        if (cliente.length === 0) {
            setError('Seleccione un cliente');
            return;
        }
        setModalValor('direccion');
        const direccionAux = await fetchConToken(
            `DireccionesClientes/GetList?paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${cliente.id}`
        );

        setDireccionesList(direccionAux);
        getCliente(direccionAux.cliente_Id);
        openModal();
    }

    async function getDireccion(direccion_id) {
        venta.direccion_Id = direccion_id;
        const direccionAux = await fetchConToken(`DireccionesClientes?id=${direccion_id}`);
        setDirecciones(direccionAux);
        getCliente(direccionAux.cliente_Id);
    }
    ///////////////////////////////////////////

    ///////////Articulos
    ///////////////////////////////////////////
    async function getArticulos(page) {
        //busqueda.value='';
        setModalValor('articulo');
        const articulosAux = await fetchConToken(
            `Articulos/GetList?paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${
                busqueda.value
            }&sucursal_Id=${getDataSession('sucursal')}`
        );
        setArticulos(articulosAux);
    }
    async function getArticulo(id) {
        const articulosAux = await fetchConToken(
            `Articulos?id=${id}&sucursal_Id=${getDataSession('sucursal')}`
        );
        //setArticulosVenta(...articulosVenta, articulosAux);

        const detalleVenta = {
            id: 0,
            venta_Id: 0,
            articulo_Id: articulosAux.id,
            no_Detalle: 'local',
            posicion: 0,
            cantidad: 1,
            clave_Unidad: articulosAux.clave_Unidad,
            precio_Unitario: articulosAux.costo_Unidad,
            descuento_Total: 0,
            precio_Total: articulosAux.costo_Unidad,
            impuesto_Total: 0,
            estatus: 'A',
            articulo: articulosAux
        };
        const newTodos = [...ventaDetalles];
        newTodos.push(detalleVenta);

        setVentaDetalles(newTodos);

    }

    ///////////////////////////////////////////

    /////////// Detalles venta
    //////////////////////////////////////////
    const handleInputChangeDetallesVenta = (event, key, campo) => {
        let detalleV = ventaDetalles.filter((det) => det.articulo_Id === key);
        detalleV[0][campo] = event.target.value;

        if (campo === 'cantidad') {
            detalleV[0]['precio_Total'] = detalleV[0]['precio_Unitario'] * detalleV[0]['cantidad'];
        }

        setVentaDetalles(ventaDetalles.map((det) => (det.articulo_Id === key ? detalleV[0] : det)));
    };
    //////////

    const loadClientes = async (query) => {
        var resp = await fetchConToken(
            `clientes/GetList?sucursal_id=${getDataSession('sucursal')}&empresa_id=${getDataSession(
                'empresa'
            )}&paginas=1&totalXpagina=50&busqueda=${query}`
        );
        return resp;
    };

    const loadArticulos = async (query) => {
        var resp = await fetchConToken(
            `Articulos/GetList?paginas=1&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession(
                'sucursal'
            )}`
        );
        return resp;
    };

    const loadDirecciones = async (query) => {
        var resp = await fetchConToken(
            `DireccionesClientes/GetList?paginas=1&totalXpagina=50&busqueda=${cliente.id}`
        );
        return resp;
    };

    const EditarArticulo = (art_id) => {
        setModalValor('articuloModificar');
        getByArticulo(art_id)
        setArtId(art_id);
        openModal();
    };

    function getByArticulo(art_id) {
        fetchConToken(`articulos?id=${art_id}&sucursal_Id=${getDataSession('sucursal')}`).then(
            (art) => {
                if (art.hasOwnProperty('status')) {
                    Object.entries(art?.errors).map(([key, value]) => {
                        Swal.fire('Error', value[0], 'error');
                        return;
                    });
                    return false;
                } else if (art.hasOwnProperty('codigo')) {
                    Swal.fire('Error', art.mensajes[0], 'error');
                    return;
                }

                setArticulo(art);

                fetchConToken(
                    `CatalogosSat/ListClaveProd?pagina=${1}&totalXpagina=${50}&busqueda=${
                        art?.clave_Prod_Serv
                    }`
                ).then((resp) => {
                    var aux = resp.find((e) => e.clave === art?.clave_Prod_Serv);
                    setInitialObject(aux);
                });

                getInitialClaveUnidad(art);
            }
        );
    }

    function GuardarArticulo(id, data) {
        return fetchConToken('Articulos', articulo, 'PUT')
            .then((response) => {
                if (response.hasOwnProperty('status') && response.status === 400) {
                    var erroresA = {};
                    Object.entries(response.errors).map(([key, value]) => {
                        erroresA[key] = value[0];
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return false;
                }
                closeModal();
                Swal.fire('Exito', 'Articulo modificado', 'success');

                ventaDetalles?.map((item) => {
                    if(item.articulo.id == response.id)
                    {
                        item.articulo.clave = response.clave;
                        item.articulo.nombre = response.nombre;
                        item.articulo.no_Identificacion = response.no_Identificacion;
                        item.articulo.clave_Prod_Serv = response.clave_Prod_Serv;
                        item.articulo.clave_Unidad = response.clave_Unidad;
                        
                        
                    }
                });

                setVentaDetalles([...ventaDetalles]);
               
            })
    }


    const getInitialClaveUnidad = async (art) => {

        await fetchConToken(
            `CatalogosSat/ClaveUnidad?claveUnidad=${art?.clave_Unidad}`
        ).then((resp) => {
            setInitialObjectClaveUnidad(resp);
        });


        await fetchConToken(
            `CatalogosSat/ClaveProd?ClaveProd=${art?.clave_Prod_Serv}`
        ).then((resp) => {
            setInitialObject(resp);
            
            /*var aux = resp.find((e) => e.clave === art?.clave_Prod_Serv);
            setInitialObject(aux);*/
        });

        
    };
    const loadDataClaveUnidad = async (query) => {
        var resp = await fetchConToken(
            `CatalogosSat/ListClaveUnidad?pagina=${1}&totalXpagina=${50}&busqueda=${query}`
        );
        return resp;
    };
    const loadData = async (query) => {
        var resp = await fetchConToken(
            `CatalogosSat/ListClaveProd?pagina=${1}&totalXpagina=${50}&busqueda=${query}`
        );
        return resp;
    };



    const sumarTraslado = (item) => {
        const filtrados = item?.impuestos_Ventas_Detalles?.filter(objeto => objeto?.concepto === "traslado");
        var totalImp =  filtrados?.reduce((acc, obj) => acc + obj?.importe_Impuesto, 0);
        return totalImp;
      };

    const sumarRetencion = (item) => {
        const filtrados = item?.impuestos_Ventas_Detalles?.filter(objeto => objeto?.concepto === "retencion");
        var totalImp = filtrados?.reduce((acc, obj) => acc + obj?.importe_Impuesto, 0); 
        return totalImp;
      };

      const obtenerNombresUnicosImpuestos = (datos) => {
        const nombresUnicos = new Set();
        datos?.forEach(item => {
          item.impuestos_Ventas_Detalles?.forEach(impuesto => {
            nombresUnicos?.add(impuesto?.tipo_Impuesto?.nombre);
          });
        });
        return Array.from(nombresUnicos);
      };


      const sumarImpuestosConcepto = (datos,nombre) => {
        const filtrados = datos?.flatMap(item => 
            item?.impuestos_Ventas_Detalles?.filter(objeto => objeto?.tipo_Impuesto?.nombre === nombre)
        );
        var totalImp = filtrados?.reduce((acc, obj) => acc + obj?.importe_Impuesto, 0);
        return totalImp;
      };

    return (
        <>
            <div className='container-fluid'>
                <form onSubmit={handleSubmit(facturar)} className='facturar' /*onReset=""*/>
                    <div className='mb-3'>
                        <div className='col-md-12'>
                            <div className=''>
                                <div className='row' style={{ textAlign: 'left' }}>
                                    <h3>Facturar Orden</h3>
                                </div>
                            </div>

                            <div className='col-md-12 text-right'>
                                {requiereRevision ? <><label>Esta venta tiene articulos pendiente de revisar</label>&nbsp; &nbsp;</> : ''}
                                {
                                venta.estatus != 'TERMINADA' && venta.estatus != 'T' && venta.estatus != 'F'  ? (
                                    <label>
                                        Esta venta no se puede facturar ya que no se ha concluido
                                    </label>
                                ) : (
                                    <button
                                        hidden={facturado}
                                        className={ requiereRevision ? 'btn btn-outline-secondary' :'btn btn-outline-success' }
                                        //onClick={ (e) => facturar() }
                                        type='submit'
                                        disabled = {requiereRevision}
                                    >
                                        &nbsp; Facturar
                                    </button>
                                )}
                                &nbsp;
                                <button
                                    type='button'
                                    hidden={!facturado}
                                    className='btn btn-outline-danger'
                                    onClick={() =>
                                        descargarFactura(
                                            cfdi.id,
                                            'Facturacion/DescargarPDF',
                                            cfdi.folio + '.pdf'
                                        )
                                    }
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-file-pdf'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                                        <path d='M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z' />
                                    </svg>
                                    &nbsp; Descargar PDF
                                </button>
                                &nbsp; &nbsp; &nbsp;
                                <button
                                    type='button'
                                    hidden={!facturado}
                                    className='btn btn-outline-warning'
                                    onClick={() =>
                                        descargarFactura(
                                            cfdi.id,
                                            'Facturacion/DescargarXML',
                                            cfdi.folio + '.xml'
                                        )
                                    }
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-filetype-xml'
                                        viewBox='0 0 16 16'
                                    >
                                        <path
                                            fillRule='evenodd'
                                            d='M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992 1.274-2.007Zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999h.706Zm4.71-.674h1.696v.674H8.4V11.85h.791v3.325Z'
                                        />
                                    </svg>
                                    &nbsp; Descargar XML
                                </button>
                                &nbsp;
                                <Link to={'..'} className='btn btn-outline-warning'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-reply'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                                    </svg>
                                    &nbsp; Regresar
                                </Link>
                            </div>
                        </div>
                    </div>

                    <p style={{ color: 'red' }}>{error}</p>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card-title'>
                                <h5>Información del cliente</h5>
                            </div>
                            {Object.entries(erroresCliente).map(([key, value]) => {
                                return (
                                    <>
                                        <p style={{ color: 'red' }}>{value}</p>
                                    </>
                                );
                            })}
                        </div>
                        <div className='text-start'>
                            <label htmlFor='id'>Cliente:</label>
                            <AsyncSelect
                            className='react-select-placeholder'
                                isClearable
                                getOptionLabel={(option) => option.rfc + '-' + option.nombre}
                                getOptionValue={(option) => option.id}
                                //defaultValue={initialObject.clave}
                                loadOptions={loadClientes}
                                onChange={(selectedItem) => {
                                    const val = selectedItem === null ? '' : selectedItem?.id;
                                    getCliente(val);
                                }}
                            />
                        </div>
                        {/*
                        <div className='col-md-12 text-right' style={{marginTop: "-45px"}}>
                            <label htmlFor='id'>
                                <button
                                    hidden={facturado}
                                    type='button'
                                    className='btn btn-outline-danger'
                                    onClick={function (event) {
                                        getClientes(1);
                                        openModal();
                                    }}
                                >
                                    Buscar cliente
                                </button>
                            </label>
                                </div>*/}
                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='text-start'>
                                    <input
                                        type='hidden'
                                        className='form-control'
                                        name='no_cliente'
                                        value={cliente?.no_Cliente || ''}
                                        onChange={handleInputChangeCliente}
                                        required
                                    />

                                    <label htmlFor='nombre'>Razón Social*:</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='nombre'
                                        value={cliente?.nombre || ''}
                                        onChange={handleInputChangeCliente}
                                        required
                                    />

                                    <label htmlFor='cp'>Codigo Postal*:</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='cp'
                                        value={direcciones?.cp || ''}
                                        onChange={handleInputChangeDireccion}
                                        disabled={facturado}
                                        required
                                    />

                                    <label htmlFor='correo'>Correo*:</label>
                                    <input
                                        type='email'
                                        className='form-control'
                                        name='correo'
                                        value={cliente?.correo || ''}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='text-start'>
                                    <label htmlFor='rfc'>RFC*:</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='rfc'
                                        value={cliente?.rfc || ''}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                        required
                                    />
                                    <p style={{ color: 'red' }}>{errorRfc}</p>
                                    <label htmlFor='uso_Cfdi'>Uso CFDI*:</label>
                                    <select
                                        className='form-control'
                                        name='uso_Cfdi'
                                        value={cliente?.uso_Cfdi}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                    >
                                       {satUsoCfdi.map((usoCfdi) => {
                                        return (
                                            <option key={usoCfdi.id} value={usoCfdi.clave}>
                                            {usoCfdi.clave + ' - ' + usoCfdi.nombre}
                                            </option>
                                        );
                                        })}
                                    </select>

                                    <label htmlFor='regimen_Fiscal_Receptor'>
                                        Regimen Fiscal*:
                                    </label>
                                    <select
                                        className='form-control'
                                        name='regimen_Fiscal_Receptor'
                                        value={cliente?.regimen_Fiscal_Receptor}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                    >
                                       {satRegimenFiscal.map((regimenfiscal) => {
                                        return (
                                            <option key={regimenfiscal.id} value={regimenfiscal.clave}>
                                            {regimenfiscal.clave + ' - ' + regimenfiscal.nombre}
                                            </option>
                                        );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='text-start'>
                                    <div className='col-md-12'></div>
                                    <label htmlFor='forma_De_Pago'>Forma de Pago:</label>
                                    <select
                                        className='form-control'
                                        name='forma_De_Pago'
                                        value={venta?.forma_De_Pago}
                                        onChange={handleInputChangeVenta}
                                        disabled={facturado}
                                        required
                                    >
                                         {satFormaPago.map((formapago) => {
                                        return (
                                            <option key={formapago.id} value={formapago.clave}>
                                            {formapago.clave + ' - ' + formapago.nombre}
                                            </option>
                                        );
                                        })}
                                    </select>

                                    <label htmlFor='metodo_Pago'>Metodo de Pago:</label>
                                    <select
                                        className='form-control'
                                        name='metodo_Pago'
                                        value={venta?.metodo_Pago}
                                        onChange={handleInputChangeVenta}
                                        disabled={facturado}
                                        required
                                    >
                                        <option value='PUE'>
                                            (PUE) Pago en una sola exhibición
                                        </option>
                                        <option value='PPD'>
                                            (PPD) Pago en Parcialidades o Diferido
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {Object.entries(erroresDirecciones).map(([key, value]) => {
                            return (
                                <>
                                    <p style={{ color: 'red' }}>{value}</p>
                                </>
                            );
                        })}
                        <div className='col-md-12'>
                            <label htmlFor='id'>Buscar Direccion</label>
                            <AsyncSelect
                            className='react-select-placeholder'
                                isClearable
                                getOptionLabel={(option) =>
                                    option?.cp +
                                    '-' +
                                    option?.calle +
                                    '-' +
                                    option?.no_Interior +
                                    '-' +
                                    option?.colonia
                                }
                                getOptionValue={(option) => option.id}
                                //defaultValue={initialObject.clave}
                                loadOptions={loadDirecciones}
                                onChange={(selectedItem) => {
                                    const val = selectedItem === null ? '' : selectedItem?.id;
                                    getDireccion(val);
                                }}
                            />
                            {/*<label htmlFor='id'>
                                <button
                                    hidden={facturado}
                                    type='button'
                                    className='btn btn-outline-danger'
                                    onClick={function (event) {
                                        getDirecciones(1);
                                    }}
                                >
                                    Buscar direccion
                                </button>
                            </label>*/}
                        </div>

                        <div className='accordion' id='accordionExample'>
                            <div className='accordion-item'>
                                <h2 className='accordion-header' id='headingOne'>
                                    <button
                                        className='accordion-button collapsed'
                                        type='button'
                                        data-bs-toggle='collapse'
                                        data-bs-target='#collapseOne'
                                        aria-expanded='true'
                                        aria-controls='collapseOne'
                                        style={{ color: '#0c63e4', backgroundColor: '#e7f1ff' }}
                                    >
                                        <h5>Datos Orden</h5>
                                    </button>
                                </h2>
                                <div
                                    id='collapseOne'
                                    className='accordion-collapse collapse'
                                    aria-labelledby='headingOne'
                                    data-bs-parent='#accordionExample'
                                >
                                    <div className='accordion-body row'>
                                        <div className='col-md-4' style={{ display: 'grid' }}>
                                            <div className='card'>
                                                <div className='text-start'>
                                                    <label htmlFor='calle'>Calle</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='calle'
                                                        value={direcciones?.calle || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />

                                                    <label htmlFor='no_Exterior'>No Exterior</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='no_Exterior'
                                                        value={direcciones?.no_Exterior || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />

                                                    <label htmlFor='no_Interior'>No Interior</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='no_Interior'
                                                        value={direcciones?.no_Interior || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-md-4' style={{ display: 'grid' }}>
                                            <div className='card'>
                                                <div className='text-start'>
                                                    <label htmlFor='colonia'>Colonia</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='colonia'
                                                        value={direcciones?.colonia || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />

                                                    <label htmlFor='poblacion'>Poblacion</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='poblacion'
                                                        value={direcciones?.poblacion || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />

                                                    <label htmlFor='ciudad'>Ciudad</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='ciudad'
                                                        value={direcciones?.ciudad || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-4' style={{ display: 'grid' }}>
                                            <div className='card'>
                                                <div className='text-start'>
                                                    <label htmlFor='estado'>Estado</label>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        name='estado'
                                                        value={direcciones?.estado || ''}
                                                        onChange={handleInputChangeDireccion}
                                                        disabled={facturado}
                                                    />

                                                <label htmlFor='pais'>Pais:</label>
                                                <select
                                                    className='form-control'
                                                    name='pais'
                                                    value={direcciones?.pais || 'México'}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                    required
                                                >
                                                    {satPais.map((pais) => {
                                                    return (
                                                        <option key={pais.id} value={pais.nombre}>
                                                        {pais.clave + ' - ' + pais.nombre}
                                                        </option>
                                                    );
                                                    })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='card-title'>
                                <div className='col-md-12'>
                                    {Object.entries(erroresV).map(([key, value]) => {
                                        return (
                                            <>
                                                <p style={{ color: 'red' }}>{value}</p>
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        <div
                            className='col-md-12 row'
                            style={{ paddingTop: '7px', paddingBottom: '7px' }}
                        >
                            {/* <div className='col-4 col-sm-4 col-md-4 '>
                            <label >Sucursal</label>
                            <select className='form-control' name='sucursal_Id' onChange={handleInputChangeSucursal} disabled={facturado}>
                                {sucursales.map(sucursal=>{
                                    return (
                                      (sucursal_id == sucursal.id) ?  (<option value={sucursal.id} selected>{sucursal.nombre}</option>) : (<option value={sucursal.id}>{sucursal.nombre}</option>)
                                    );
                                })}
                            </select>
                            </div>
                            <div className='col-4 col-sm-4 col-md-4 '>
                            <label>Serie</label>
                            <select className='form-control' onChange={handleInputChangeSerie} disabled={facturado}>
                                {series.map(s=>{
                                    return (
                                       s === s.id ? <option value={s.id} selected>{s.serie}</option> : <option value={s.id}>{s.serie}</option>
                                    );
                                })}
                            </select>
                            </div>
                            */}
                            {/*
                            <div className='col-md-12'>
                                <label htmlFor='id'>
                                        Buscar Articulo
                    
                                </label>
                                <AsyncSelect
                                        isClearable
                                        getOptionLabel={(option) =>
                                            option.clave + '-' + option.nombre + "- $" + option.costo_Unidad
                                        }
                                        getOptionValue={(option) => option.id}
                                        //defaultValue={initialObject.clave}
                                        loadOptions={loadArticulos}
                                        onChange={(selectedItem) => {
                                            const val =
                                                selectedItem === null ? '' : selectedItem?.id;
                                                getArticulo(val);
                                        }}
                                        />
                            </div>*/}
                            {/*
                            <div className='col-12 col-sm-12 col-md-12 text-right'>
                            <label htmlFor='id'>
                                    <button
                                        hidden={facturado}
                                        type='button'
                                        className='btn btn-outline-danger'
                                        onClick={function (event) {
                                            getArticulos(1);
                                            openModal();
                                        }}
                                    >
                                        Buscar Articulo
                                    </button>
                                </label>
                                    </div>*/}
                        </div>
                        <div className='col-md-12' style={{ display: 'grid' }}>
                            <div className='card mb-3 '>
                                <div className='text-start'>
                                    <div className='card col-12 col-sm-12 col-md-12'>
                                        {Object.entries(erroresArticulos).map(([key, value]) => {
                                            return (
                                                <>
                                                    <p style={{ color: 'red' }}>{value}</p>
                                                </>
                                            );
                                        })}
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className='table'>
                                                <thead>
                                                    { requiereRevision ? 
                                                      <tr>
                                                        <th  colSpan={9} className='text-right'> 
                                                            <button className='btn btn-danger' type='button' onClick={() =>revisarArticulos()}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                                                </svg> 
                                                                &nbsp;&nbsp;Revisar Articulos
                                                            </button>
                                                        </th>
                                                      </tr> : ''
                                                    }
                                                    <tr>
                                                        <th>Articulo</th>
                                                        <th width={100}>Claves</th>
                                                        <th width={100}>Cantidad</th>
                                                        <th width={200}>Precio Unitario</th>
                                                        <th width={200}>Impuestos</th>
                                                        <th width={200}>Precio Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ventaDetalles?.map((item) => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{(item.nombre_Articulo === null || item.nombre_Articulo.length === 0) ? item.articulo?.nombre : item.nombre_Articulo}</td>

                                                                <td className='text-center'>

                                                                { (  item.articulo.clave.length === 0  || 
                                                                         item.articulo.clave_Prod_Serv.length === 0 ||
                                                                         item.articulo.no_Identificacion.length === 0 ||
                                                                         item.articulo.clave_Unidad.length === 0  ) ? 
                                                                    <button 
                                                                       type='button' 
                                                                       className='btn btn-outline-danger'
                                                                       onClick={(event) => EditarArticulo(item.articulo.id) }
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                                                            <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                                            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                                        </svg>
                                                                    </button>
                                                                         :
                                                                    <button 
                                                                         type='button' 
                                                                         className='btn btn-outline-primary'
                                                                         onClick={(event) => EditarArticulo(item.articulo.id) }
                                                                    >
                                                                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                                                               <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                                                               <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                                                           </svg>
                                                                    </button>
                                                                    
                                                                }
                                                                </td>
                                                      
                                                                <td className='text-right'>
                                                                    {item.cantidad}
                                                                </td>
                                                                <td className='text-center'>
                                                                    {currency(item.precio_Unitario)}
                                                                </td>
                                                                <td className='text-right'>
                                                                    {item?.impuestos_Ventas_Detalles?.map(imp=>{
                                                                            return <>
                                                                            <div className='row'>
                                                                                <div className='card'>
                                                                                    <div className='card-title text-center'>
                                                                                        <small><b>{imp?.tipo_Impuesto?.nombre}</b></small>
                                                                                    </div>
                                                                                    <div className='card-body text-center'>
                                                                                        <div className='col-md-12'>
                                                                                                <p>{currency(imp?.importe_Impuesto)}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            </>
                                                                        })}
                                                                </td>
                                                                <td className='text-right'>
                                                                {currency(item.precio_Total + sumarTraslado(item) - sumarRetencion(item))}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}


                                                      <tr>
                                                        <td colSpan={6} className='text-right'>
                                                            Subtotal: {'   '}
                                                            {currency(
                                                                ventaDetalles.reduce(
                                                                    (a, v) => (a = a + v.precio_Total),
                                                                    0
                                                                )
                                                            )}

                                                            {obtenerNombresUnicosImpuestos(ventaDetalles).map(imp=>{
                                                                    return <><p>{imp}: {'   '}
                                                                    {currency( sumarImpuestosConcepto(ventaDetalles,imp))}
                                                                    </p></>
                                                                })}

                                                            <p>Total:{'   '}
                                                            {currency(
                                                                  ventaDetalles.reduce(
                                                                    (a, v) => (a = a + v.precio_Total + sumarTraslado(v) - sumarRetencion(v)),
                                                                    0
                                                                )                                                              
                                                            )}</p> 

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Modal isOpen={isOpenModal} closeModal={closeModal}>
                {modalValor === 'cliente' ? (
                    <>
                        {' '}
                        <br />
                        <div className='row'>
                            <div className='col-md-2 tex-left'>
                                <label>Buscar</label>
                            </div>
                            <div className='col-md-8 '>
                                <input type='text' className='form-control' {...busqueda} />
                            </div>
                            <div className='col-md-2 text-left'>
                                <button
                                    type='button'
                                    className='btn btn-outline-secondary'
                                    onClick={() => getClientes(1)}
                                    style={{ border: 'none' }}
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='16'
                                        height='16'
                                        fill='currentColor'
                                        className='bi bi-search'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <br></br>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th width='40px'>#No</th>
                                    <th>Clave</th>
                                    <th>Nombre</th>
                                    <th className='text-center'>RFC</th>
                                    <th width='160px'>Estatus</th>
                                    <th className='text-center'>Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientes.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.no_cliente}</td>
                                            <td>{item.nombre}</td>
                                            <td>{item.rfc}</td>
                                            <td>{item.estatus === 'A' ? 'Activo' : 'Inactivo'}</td>
                                            <td className='text-center'>
                                                <button
                                                    className='btn btn-outline-warning'
                                                    type='button'
                                                    onClick={function (event) {
                                                        getCliente(item.id);
                                                        closeModal();
                                                    }}
                                                >
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='25'
                                                        height='25'
                                                        fill='currentColor'
                                                        className='bi bi-check2'
                                                        viewBox='0 0 16 16'
                                                    >
                                                        <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <Pagination
                            consumirPaginacion={getClientes}
                            elementos={clientes.length}
                            totalxPagina={totalxPagina}
                        />
                    </>
                ) : (
                    ''
                )}
                {modalValor === 'direccion' ? (
                    <>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th width='40px'>#No</th>
                                    <th>Codigo Postal</th>
                                    <th>Calle</th>
                                    <th className='text-center'>No. Exterior</th>
                                    <th width='160px'>No. Interior</th>
                                    <th className='text-center'>Colonia</th>
                                    <th className='text-center'>Poblacion</th>
                                    <th className='text-center'>Estado</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {direccionesList.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.cp}</td>
                                            <td>{item.calle}</td>
                                            <td>{item.no_Exterior}</td>
                                            <td>{item.no_Interior}</td>
                                            <td>{item.colonia}</td>
                                            <td>{item.poblacion}</td>
                                            <td>{item.estado}</td>
                                            <td className='text-center'>
                                                <button
                                                    className='btn btn-outline-warning'
                                                    type='button'
                                                    onClick={function (event) {
                                                        getDireccion(item.id);
                                                        closeModal();
                                                    }}
                                                >
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='25'
                                                        height='25'
                                                        fill='currentColor'
                                                        className='bi bi-check2'
                                                        viewBox='0 0 16 16'
                                                    >
                                                        <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <Pagination
                            consumirPaginacion={getDirecciones}
                            elementos={direcciones.length}
                            totalxPagina={totalxPagina}
                        />
                    </>
                ) : (
                    ''
                )}

                {modalValor === 'articulo' ? (
                    <>
                        {' '}
                        <br />
                        <div className='row'>
                            <div className='col-md-2 tex-left'>
                                <label>Buscar</label>
                            </div>
                            <div className='col-md-8 '>
                                <input type='text' className='form-control' {...busqueda} />
                            </div>
                            <div className='col-md-2 text-left'>
                                <button
                                    type='button'
                                    className='btn btn-outline-secondary'
                                    onClick={() => getArticulos(1)}
                                    style={{ border: 'none' }}
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='16'
                                        height='16'
                                        fill='currentColor'
                                        className='bi bi-search'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <br></br>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th width='40px'>#No</th>
                                    <th>Clave</th>
                                    <th>Nombre</th>
                                    <th className='text-center'>No Identificacion</th>
                                    <th width='160px'>Clave Prod.Ser.</th>
                                    <th className='text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {articulos.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.clave}</td>
                                            <td>{item.nombre}</td>
                                            <td>{item.no_Identificacion}</td>
                                            <td>{item.clave_Prod_Serv}</td>
                                            <td className='text-center'>
                                                <button
                                                    className='btn btn-outline-warning'
                                                    type='button'
                                                    onClick={function (event) {
                                                        getArticulo(item.id);
                                                        closeModal();
                                                    }}
                                                >
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='25'
                                                        height='25'
                                                        fill='currentColor'
                                                        className='bi bi-check2'
                                                        viewBox='0 0 16 16'
                                                    >
                                                        <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}

                            </tbody>
                        </table>
                        <Pagination
                            consumirPaginacion={getClientes}
                            elementos={clientes.length}
                            totalxPagina={totalxPagina}
                        />
                    </>
                ) : (
                    ''
                )}

{modalValor === 'articuloModificar' ? (
                    <>
                        {' '}
                        <br />
                        <div className='card-body text-start'>
                        <div className='row'>
                            <div className='col-md-10 tex-left'>
                            <h3 className='form-label'>Editar Claves de Articulo</h3>
                            </div>
                            <div className='col-md-2 '>
                                <button
                                    type='button'
                                    className='btn btn-success'
                                    onClick={() => GuardarArticulo()}
                                >
                                  Guardar
                                </button>
                            </div>
                        </div>
                      
                       
                        

<label htmlFor='clave' className='form-label'>
        Clave*
    </label>
    <input
        type='text'
        className='form-control'
        name='clave'
        required={true}
        maxLength={100}
        value={articulo.clave || ''}
        onChange={handleInputChangeArticulo}
    />

    <label htmlFor='nombre' className='form-label'>
        Nombre*
    </label>
    <input
        type='text'
        className='form-control'
        name='nombre'
        required={true}
        maxLength={100}
        value={articulo.nombre || ''}
        onChange={handleInputChangeArticulo}
    />

    <label htmlFor='clave_Prod_Serv' className='form-label'>
        Clave del Producto o Servicio SAT
    </label>
    <AsyncSelect
        isClearable
        className='react-select-placeholder'
        getOptionLabel={(option) =>
            option.clave + '-' + option.nombre
        }
        getOptionValue={(option) => option.clave}
        defaultOptions
        value={initialObject}
        loadOptions={loadData}
        onChange={(selectedItem) => {
            const val =
                selectedItem === null ? '' : selectedItem?.clave;
            articulo.clave_Prod_Serv = val;
            setInitialObject(selectedItem);
        }}
    />

    <label htmlFor='no_Identificacion' className='form-label'>
        Código de Identificación*
    </label>
    <input
        type='text'
        className='form-control'
        name='no_Identificacion'
        required={true}
        maxLength={100}
        placeholder="Escriba código de identificación"
        value={articulo.no_Identificacion || ''}
        onChange={handleInputChangeArticulo}
    />

    <label htmlFor='clave_Unidad' className='form-label'>
        Clave de Unidad (SAT)*
    </label>
    <AsyncSelect
    className='react-select-placeholder'
        isClearable
        getOptionLabel={(option) =>
            option.clave + '-' + option.nombre
        }
        getOptionValue={(option) => option.clave}
        defaultOptions 
        value={initialObjectClaveUnidad}
        loadOptions={loadDataClaveUnidad}
        onChange={(selectedItem) => {
            const val =
                selectedItem === null ? '' : selectedItem?.clave;
            articulo.clave_Unidad = val;
            setInitialObjectClaveUnidad(selectedItem);
        }}
    />
</div>
                    </>
                ) : (
                    ''
                )}

            </Modal>
        </>
    );
};

const useFormInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
    return {
        value,
        onChange: handleChange
    };
};
export { Facturacion };
